import { render, staticRenderFns } from "./ContestPage.vue?vue&type=template&id=4579ffe0&scoped=true"
import script from "./ContestPage.vue?vue&type=script&lang=js"
export * from "./ContestPage.vue?vue&type=script&lang=js"
import style0 from "./ContestPage.vue?vue&type=style&index=0&id=4579ffe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4579ffe0",
  null
  
)

export default component.exports